var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 664 367",
    width: 664,
    height: 367,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 287.000,80.125 C 286.869,77.513 286.500,77.625 286.000,75.125",
    strokeWidth: 4.145,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 286.000,75.125 C 283.962,65.686 282.869,66.513 279.000,58.125",
    strokeWidth: 2.943,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 279.000,58.125 C 273.402,48.658 273.462,49.686 265.000,43.125",
    strokeWidth: 2.591,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 265.000,43.125 C 252.211,34.582 252.902,35.158 238.000,31.125",
    strokeWidth: 2.25,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.000,31.125 C 214.421,24.621 215.211,25.582 191.000,25.125",
    strokeWidth: 1.597,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 191.000,25.125 C 165.741,24.019 167.921,25.621 145.000,33.125",
    strokeWidth: 1.574,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 145.000,33.125 C 115.334,41.419 124.741,42.019 109.000,61.125",
    strokeWidth: 1.493,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.000,61.125 C 94.950,108.303 97.334,97.419 109.000,145.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 109.000,145.125 C 133.050,184.833 123.950,184.303 167.000,213.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M 167.000,213.125 C 214.899,246.034 211.050,249.833 265.000,275.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M 265.000,275.125 C 308.804,298.513 307.899,300.034 353.000,321.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M 353.000,321.125 C 395.921,334.881 373.304,331.513 394.000,341.125",
    strokeWidth: 1.185,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M 394.000,341.125 C 369.429,348.722 391.921,347.881 345.000,347.125",
    strokeWidth: 1.774,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M 345.000,347.125 C 292.863,339.932 292.929,343.722 241.000,331.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M 241.000,331.125 C 186.279,324.041 186.863,321.932 133.000,311.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M 133.000,311.125 C 77.429,308.872 87.279,300.041 43.000,283.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M 43.000,283.125 C 14.432,248.912 19.929,265.872 18.000,225.125",
    strokeWidth: 1.686,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M 18.000,225.125 C 36.610,214.303 20.432,208.912 55.000,203.125",
    strokeWidth: 1.569,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M 55.000,203.125 C 62.030,198.671 62.110,198.803 69.000,194.125",
    strokeWidth: 2.286,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M 69.000,194.125 C 73.162,190.241 73.530,191.171 78.000,188.125",
    strokeWidth: 2.986,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M 78.000,188.125 C 81.492,187.563 81.162,186.741 85.000,187.125",
    strokeWidth: 3.573,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M 85.000,187.125 C 89.484,186.340 89.492,186.563 94.000,186.125",
    strokeWidth: 3.586,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M 94.000,186.125 C 100.000,186.125 99.984,185.840 106.000,186.125",
    strokeWidth: 3.318,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M 256.000,183.125 C 248.566,187.737 248.500,187.625 241.000,192.125",
    strokeWidth: 4.658,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M 241.000,192.125 C 223.500,202.125 223.566,202.237 206.000,212.125",
    strokeWidth: 1.991,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M 206.000,212.125 C 184.684,223.606 185.000,224.125 164.000,236.125",
    strokeWidth: 1.589,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M 164.000,236.125 C 146.901,246.977 146.684,246.606 130.000,258.125",
    strokeWidth: 1.64,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M 130.000,258.125 C 119.641,269.046 123.401,262.477 117.000,267.125",
    strokeWidth: 2.364,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M 117.000,267.125 C 117.370,258.506 114.141,265.046 119.000,250.125",
    strokeWidth: 3.526,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M 119.000,250.125 C 121.618,240.654 120.870,240.506 124.000,231.125",
    strokeWidth: 2.83,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M 124.000,231.125 C 125.831,220.602 125.118,226.654 126.000,222.125",
    strokeWidth: 3.356,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M 126.000,222.125 C 126.022,231.185 126.331,225.102 125.000,240.125",
    strokeWidth: 4.163,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M 125.000,240.125 C 123.419,248.612 124.022,248.685 122.000,257.125",
    strokeWidth: 3.097,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M 122.000,257.125 C 121.419,263.739 120.919,263.612 120.000,270.125",
    strokeWidth: 3.09,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M 120.000,270.125 C 117.701,276.722 119.419,272.739 118.000,275.125",
    strokeWidth: 3.796,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M 118.000,275.125 C 119.703,264.383 119.201,268.722 123.000,254.125",
    strokeWidth: 4.095,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M 123.000,254.125 C 128.326,236.101 128.703,236.383 136.000,219.125",
    strokeWidth: 2.049,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M 136.000,219.125 C 145.576,199.889 144.826,199.601 156.000,181.125",
    strokeWidth: 1.761,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M 156.000,181.125 C 166.042,164.150 165.576,163.889 176.000,147.125",
    strokeWidth: 1.662,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M 176.000,147.125 C 180.930,137.230 181.542,137.650 187.000,128.125",
    strokeWidth: 2.102,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M 187.000,128.125 C 191.688,122.764 190.930,122.230 196.000,117.125",
    strokeWidth: 2.694,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M 196.000,117.125 C 197.758,113.927 198.188,114.264 200.000,111.125",
    strokeWidth: 3.426,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M 200.000,111.125 C 201.574,108.096 201.758,108.927 204.000,107.125",
    strokeWidth: 3.946,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M 204.000,107.125 C 209.143,104.982 206.574,106.096 210.000,107.125",
    strokeWidth: 4.804,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M 210.000,107.125 C 210.745,114.674 212.143,112.482 210.000,122.125",
    strokeWidth: 4.078,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M 210.000,122.125 C 207.693,144.738 207.745,144.674 204.000,167.125",
    strokeWidth: 1.815,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M 204.000,167.125 C 198.181,192.995 199.693,193.238 194.000,219.125",
    strokeWidth: 1.425,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M 194.000,219.125 C 190.893,243.112 190.181,242.995 188.000,267.125",
    strokeWidth: 1.406,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M 188.000,267.125 C 185.310,284.654 185.893,284.612 184.000,302.125",
    strokeWidth: 1.679,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M 184.000,302.125 C 184.427,307.698 183.810,304.654 185.000,307.125",
    strokeWidth: 2.937,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M 185.000,307.125 C 186.459,303.182 185.927,306.198 187.000,299.125",
    strokeWidth: 4.322,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M 201.000,252.125 C 203.408,255.985 203.000,256.125 205.000,260.125",
    strokeWidth: 5.431,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M 205.000,260.125 C 204.703,265.611 205.908,262.485 206.000,265.125",
    strokeWidth: 5.012,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M 206.000,265.125 C 209.662,261.258 208.703,264.111 213.000,257.125",
    strokeWidth: 4.48,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M 213.000,257.125 C 219.433,247.600 220.162,248.258 227.000,239.125",
    strokeWidth: 2.791,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M 227.000,239.125 C 234.779,227.886 231.933,233.600 238.000,229.125",
    strokeWidth: 2.877,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M 238.000,229.125 C 239.373,236.600 241.279,230.386 240.000,244.125",
    strokeWidth: 3.912,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M 240.000,244.125 C 240.000,248.625 240.373,248.600 240.000,253.125",
    strokeWidth: 3.688,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M 240.000,253.125 C 238.267,259.283 240.000,256.125 240.000,259.125",
    strokeWidth: 4.005,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M 240.000,259.125 C 245.860,256.097 243.767,258.783 251.000,252.125",
    strokeWidth: 4.314,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M 251.000,252.125 C 256.428,247.042 256.860,247.597 262.000,242.125",
    strokeWidth: 3.23,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M 262.000,242.125 C 265.882,237.125 264.928,239.542 268.000,237.125",
    strokeWidth: 3.643,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M 268.000,237.125 C 268.581,239.611 269.382,237.125 269.000,242.125",
    strokeWidth: 4.597,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M 269.000,242.125 C 267.962,248.219 269.581,245.611 270.000,249.125",
    strokeWidth: 4.604,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M 270.000,249.125 C 274.393,248.289 272.462,250.219 278.000,246.125",
    strokeWidth: 4.626,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M 278.000,246.125 C 281.137,241.735 281.893,243.789 285.000,240.125",
    strokeWidth: 3.831,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M 285.000,240.125 C 287.722,240.089 287.137,239.235 290.000,241.125",
    strokeWidth: 4.702,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M 290.000,241.125 C 292.851,244.553 293.222,242.589 296.000,245.125",
    strokeWidth: 4.832,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M 296.000,245.125 C 298.887,244.741 298.351,245.553 301.000,243.125",
    strokeWidth: 4.378,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M 301.000,243.125 C 307.660,238.228 307.387,238.241 313.000,232.125",
    strokeWidth: 3.129,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M 313.000,232.125 C 323.087,222.714 321.660,222.228 329.000,211.125",
    strokeWidth: 2.349,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M 329.000,211.125 C 334.615,197.341 335.587,198.214 338.000,183.125",
    strokeWidth: 2.079,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M 338.000,183.125 C 337.667,167.601 339.615,176.341 339.000,169.125",
    strokeWidth: 2.646,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M 339.000,169.125 C 340.177,180.875 341.167,171.601 345.000,191.125",
    strokeWidth: 3.368,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M 345.000,191.125 C 356.712,214.954 356.177,214.875 371.000,237.125",
    strokeWidth: 1.601,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M 371.000,237.125 C 388.437,258.240 385.712,259.954 403.000,281.125",
    strokeWidth: 1.361,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M 403.000,281.125 C 412.195,297.344 412.937,296.740 420.000,314.125",
    strokeWidth: 1.622,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M 420.000,314.125 C 424.510,320.349 422.195,318.844 423.000,324.125",
    strokeWidth: 2.56,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M 423.000,324.125 C 418.976,329.012 421.510,327.849 414.000,329.125",
    strokeWidth: 3.108,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M 414.000,329.125 C 395.979,329.418 396.976,329.512 379.000,325.125",
    strokeWidth: 2.02,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M 379.000,325.125 C 351.886,318.531 352.479,318.418 327.000,307.125",
    strokeWidth: 1.427,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M 327.000,307.125 C 302.781,296.620 303.886,296.531 283.000,281.125",
    strokeWidth: 1.411,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M 283.000,281.125 C 269.311,271.682 272.781,273.120 267.000,260.125",
    strokeWidth: 1.844,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M 267.000,260.125 C 265.056,244.075 264.811,249.182 274.000,236.125",
    strokeWidth: 2.127,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M 274.000,236.125 C 309.664,209.723 305.556,208.075 348.000,188.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M 348.000,188.125 C 382.876,173.756 380.664,169.723 416.000,156.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M 416.000,156.125 C 445.874,141.580 444.876,140.756 472.000,122.125",
    strokeWidth: 1.125,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M 472.000,122.125 C 495.717,107.129 492.874,106.580 510.000,86.125",
    strokeWidth: 1.27,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M 510.000,86.125 C 517.773,66.725 521.217,69.629 523.000,47.125",
    strokeWidth: 1.622,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M 523.000,47.125 C 523.800,43.285 523.773,44.225 522.000,41.125",
    strokeWidth: 2.846,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M 522.000,41.125 C 517.795,35.924 518.800,37.285 513.000,35.125",
    strokeWidth: 3.185,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M 513.000,35.125 C 507.165,34.960 508.795,34.424 504.000,38.125",
    strokeWidth: 3.42,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M 504.000,38.125 C 496.905,44.772 498.165,43.960 495.000,53.125",
    strokeWidth: 2.872,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M 495.000,53.125 C 491.000,74.099 490.405,73.272 491.000,95.125",
    strokeWidth: 1.795,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M 491.000,95.125 C 492.415,124.178 491.000,124.099 495.000,153.125",
    strokeWidth: 1.394,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M 495.000,153.125 C 499.031,180.049 497.415,180.178 501.000,207.125",
    strokeWidth: 1.312,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M 501.000,207.125 C 504.882,235.642 503.031,235.049 503.000,263.125",
    strokeWidth: 1.31,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M 503.000,263.125 C 500.938,272.718 502.382,272.142 496.000,280.125",
    strokeWidth: 2.049,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M 496.000,280.125 C 491.976,284.637 492.938,284.718 487.000,287.125",
    strokeWidth: 2.822,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M 487.000,287.125 C 482.470,289.125 482.976,289.137 478.000,289.125",
    strokeWidth: 3.306,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M 478.000,289.125 C 474.192,288.721 474.470,289.125 471.000,287.125",
    strokeWidth: 3.679,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M 471.000,287.125 C 467.026,285.689 468.192,285.721 466.000,283.125",
    strokeWidth: 3.91,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M 466.000,283.125 C 464.991,278.967 465.026,280.689 467.000,277.125",
    strokeWidth: 4.07,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M 467.000,277.125 C 472.420,274.434 470.991,273.467 478.000,272.125",
    strokeWidth: 3.423,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M 478.000,272.125 C 486.808,267.600 486.920,268.434 496.000,265.125",
    strokeWidth: 2.76,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M 496.000,265.125 C 500.024,264.841 499.808,264.100 504.000,265.125",
    strokeWidth: 3.428,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M 504.000,265.125 C 507.457,264.738 507.024,265.341 510.000,266.125",
    strokeWidth: 3.857,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M 510.000,266.125 C 512.890,268.312 512.957,267.738 515.000,271.125",
    strokeWidth: 3.888,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M 515.000,271.125 C 517.199,279.991 518.890,276.312 522.000,282.125",
    strokeWidth: 3.3,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M 522.000,282.125 C 528.500,282.125 526.199,283.991 533.000,279.125",
    strokeWidth: 4.254,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M 533.000,279.125 C 536.439,274.576 537.500,276.125 540.000,270.125",
    strokeWidth: 3.526,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M 540.000,270.125 C 542.041,266.493 542.439,267.076 545.000,264.125",
    strokeWidth: 3.7,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M 545.000,264.125 C 547.959,261.309 547.041,262.493 550.000,262.125",
    strokeWidth: 4.556,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M 550.000,262.125 C 551.802,266.895 552.959,263.309 555.000,268.125",
    strokeWidth: 4.586,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M 555.000,268.125 C 559.228,268.286 558.302,269.395 563.000,267.125",
    strokeWidth: 4.54,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M 563.000,267.125 C 565.716,265.902 565.728,266.286 568.000,264.125",
    strokeWidth: 4.288,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M 568.000,264.125 C 570.277,262.341 570.216,262.402 572.000,260.125",
    strokeWidth: 4.241,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M 572.000,260.125 C 573.605,257.683 573.777,257.841 575.000,255.125",
    strokeWidth: 4.936,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M 575.000,255.125 C 577.266,252.306 576.605,252.183 578.000,249.125",
    strokeWidth: 4.212,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M 578.000,249.125 C 578.407,245.585 578.766,245.806 578.000,242.125",
    strokeWidth: 4.05,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M 578.000,242.125 C 578.922,234.781 577.407,237.085 576.000,232.125",
    strokeWidth: 3.661,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M 576.000,232.125 C 570.441,230.561 573.422,229.781 567.000,232.125",
    strokeWidth: 4.353,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M 567.000,232.125 C 565.000,234.625 564.941,233.061 565.000,237.125",
    strokeWidth: 4.337,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M 565.000,237.125 C 565.717,239.774 565.000,239.625 567.000,242.125",
    strokeWidth: 4.291,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M 567.000,242.125 C 568.167,246.473 568.717,245.274 571.000,248.125",
    strokeWidth: 3.993,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M 571.000,248.125 C 575.147,249.767 574.167,249.973 579.000,249.125",
    strokeWidth: 3.867,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M 579.000,249.125 C 584.243,247.607 584.147,248.267 589.000,245.125",
    strokeWidth: 3.56,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M 589.000,245.125 C 595.362,240.877 595.743,241.607 602.000,237.125",
    strokeWidth: 3.054,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M 602.000,237.125 C 607.171,231.871 606.862,234.377 612.000,232.125",
    strokeWidth: 3.23,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M 612.000,232.125 C 616.917,234.670 616.671,232.371 621.000,238.125",
    strokeWidth: 4.25,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M 621.000,238.125 C 622.556,241.224 623.417,240.170 625.000,243.125",
    strokeWidth: 4.084,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M 625.000,243.125 C 627.465,245.306 627.056,244.724 630.000,245.125",
    strokeWidth: 4.171,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M 630.000,245.125 C 634.665,243.983 634.465,244.806 639.000,242.125",
    strokeWidth: 4.287,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M 639.000,242.125 C 642.180,238.605 641.665,240.983 644.000,239.125",
    strokeWidth: 4.171,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M 644.000,239.125 C 647.596,242.795 645.680,239.605 646.000,244.125",
    strokeWidth: 4.881,
    stroke: "black",
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg01);
export default __webpack_public_path__ + "static/media/01.fbc7c9182ab161d29af82bd54690873e.svg";
export { ForwardRef as ReactComponent };